import React from 'react';
import { motion } from 'framer-motion';
import { FaUserShield, FaUserTie, FaUser } from 'react-icons/fa';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';
import { UserType } from '../Constants.ts';


const typeInfo: Record<UserType, {
    icon: React.ReactNode;
    bg: string;
    text: string;
    description: string;
}> = {
    [UserType.User]: {
        icon: <FaUser className="me-1" />,
        bg: '#e6f0fa',
        text: '#2164a8',
        description: 'Users have limited access to assigned features and reports.',
    },
    [UserType.Manager]: {
        icon: <FaUserTie className="me-1" />,
        bg: '#fff8e1',
        text: '#d29b00',
        description: 'Managers can assign roles and view reports.',
    },
    [UserType.Admin]: {
        icon: <FaUserShield className="me-1" />,
        bg: '#fdecea',
        text: '#c0392b',
        description: 'Admins can manage users, roles, and settings.',
    },
};

interface Props {
    userType: UserType,
    noTitle: boolean
}

const UserTypeBadge: React.FC<Props> = ({ userType, noTitle }) => {
    const info = typeInfo[userType];

    return (
        <motion.div
            initial={{ opacity: 0, y: -4 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.3 }}
        >
            <OverlayTrigger
                placement="right"
                overlay={noTitle ? <></> : <Tooltip id="tooltip-user-type">{info.description}</Tooltip>}
            >
                <span
                    style={{
                        backgroundColor: info.bg,
                        color: info.text,
                        padding: '4px 10px',
                        borderRadius: '16px',
                        fontSize: '0.75rem',
                        fontWeight: 500,
                        display: 'inline-flex',
                        alignItems: 'center',
                        cursor: 'default',
                    }}
                >
                    {info.icon}
                    {UserType[userType]}
                </span>
            </OverlayTrigger>
        </motion.div>
    );
};

export default UserTypeBadge;
